var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('span',_vm._g({staticClass:"app-icon"},_vm.$listeners),[_c('span',{staticClass:"app-icon__icon",domProps:{"innerHTML":_vm._s(_vm.icon)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }